import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const o = { stroke: "#12303B", strokeWidth: 2.5, strokeLinejoin: "round", strokeLinecap: "round" };

const MouseSvg = () => (
  <svg viewBox="0 0 64 56" className="w-full h-full">
    <path d="M50 44c8 0 12-6 8-12" fill="none" {...o} />
    <ellipse cx="32" cy="38" rx="20" ry="14" fill="#B8C2C7" {...o} />
    <circle cx="18" cy="16" r="8" fill="#F48FB1" {...o} />
    <circle cx="38" cy="14" r="8" fill="#F48FB1" {...o} />
    <ellipse cx="28" cy="26" rx="14" ry="12" fill="#B8C2C7" {...o} />
    <circle cx="22" cy="24" r="2.2" fill="#12303B" /><circle cx="32" cy="24" r="2.2" fill="#12303B" />
    <circle cx="27" cy="31" r="2.4" fill="#E8615A" />
    <path d="M23 34c2 2 6 2 8 0" fill="none" {...o} strokeWidth="2" />
    <path d="M18 32l-8 -1M18 34l-8 2M36 32l8-1M36 34l8 2" {...o} strokeWidth="1.5" fill="none" />
  </svg>
);

export const HiddenMouse = () => {
  const [found, setFound] = useState(false);

  useEffect(() => {
    if (!found) return undefined;
    const t = setTimeout(() => setFound(false), 3200);
    return () => clearTimeout(t);
  }, [found]);

  return (
    <div className="absolute bottom-0 right-6 sm:right-16 z-10">
      <AnimatePresence>
        {found && (
          <motion.div
            data-testid="mouse-found-message"
            initial={{ opacity: 0, y: 10, scale: 0.8 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 10 }}
            className="absolute bottom-full right-0 mb-3 w-56 sm:w-auto sm:whitespace-nowrap text-right rounded-2xl border-2 border-ink bg-butter px-4 py-2 font-display text-ink text-lg shadow-[4px_4px_0_#12303B]"
          >
            You found me! The mouse saves the day!
          </motion.div>
        )}
      </AnimatePresence>
      <motion.button
        type="button"
        aria-label="A tiny hidden mouse"
        data-testid="hidden-mouse"
        onClick={() => setFound(true)}
        className="block w-12 h-11 origin-bottom"
        animate={found ? { y: [0, -18, 0, -12, 0, -18, 0], rotate: [0, -15, 15, -15, 15, 0, 0], scale: [1, 1.2, 1, 1.2, 1, 1.2, 1] } : { y: 0, rotate: 0, scale: 1 }}
        transition={{ duration: 1.6, ease: "easeInOut" }}
      >
        <MouseSvg />
      </motion.button>
    </div>
  );
};
